import React from 'react'
import AlphabetCell from '../AlphabetCell'

const KeylessCipherTable = ({ text, colPositions, rowPositions, rails, isDecryption, selectedCharCol }) => {

    var keyArray = [];
    for (let i = 0; i < rails; i++) {
        keyArray.push("");
    }

    var count = 0;

    // console.log("Positions in Table : ", positions);
    // console.log("Keyyy in Table : ", rails);
    // console.log("Text in Table : ", text);

    return (
        <div style={{ textAlign: "center" }}>
            {
                keyArray.map((row, rowIndex) => (
                    <div key={Math.random()} style={{ margin: 0 }}>{
                        text.map((col, colIndex)=> {
                            if (colPositions[count] === rowIndex && rowIndex[colIndex] === colIndex){
                                console.log("Areeyyy Bhaiiii Column dekh : ",colPositions[count])
                                count++;
                            }

                        return(
                            <div key={Math.random()} style={{ display: "inline-block", margin: 0 }}>
                                <AlphabetCell
                                    key={Math.random()}
                                    keepSmall={true}
                                    text={isDecryption ? colPositions[count] === rowIndex && rowIndex[colIndex] === colIndex  ? col : "-" : colPositions[colIndex] === rowIndex ? col : "-"}
                                    isLast={colIndex === text.length - 1}
                                    isPlain={isDecryption ? colPositions[colIndex] === rowIndex : false}
                                    isCipher={isDecryption ? false : colPositions[colIndex] === rowIndex && selectedCharCol === colIndex} />
                            </div>
                        )}
                        )
                    }
                        <br />
                    </div>
                )
                )
            }
        </div>
    );
}

KeylessCipherTable.defaultProps = {
    isDecryption: false,
    rowPositions: []
}

export default KeylessCipherTable
